import { useStaticQuery, graphql } from "gatsby";

export const Content = () => {
  return useStaticQuery(graphql`
    {
      allStrapiPage(filter: { name_: { eq: "CONTACT" } }) {
        nodes {
          seo {
            id
            title
            keywords {
              data{
                keywords
              }
            }
            description {
              data{
                description
              }
            }
           
          }

          # section title
          section_title_description {
            title
          }

          # featured block
          featured_block {
            name_
            title
            content {
              data{
                content
              }
            }

            image_alt {
              data {
                image_alt
              }
            }
            image {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(quality: 100)
                }
              }
            }
          }

          # blocking for enquiryform
          content_block {
            name_
            description {
                data{
                  description
                }
              }
          }
          locale
        }
        pageInfo {
          perPage
        }
      }
    }
  `);
};
